up.$compiler('[privacy-policy-dialog]', ($element) => {
  let html = $element.html();
  up.layer.open({ fragment: html, target: '.privacy-policy-dialog', dismissable: false })

  $element.remove(); // we need to remove the content in the background because it would receive the checkbox check instead of the modal checkbox.
});
